'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'flag-pennant';
var width = 448;
var height = 512;
var aliases = [128681,"pennant"];
var unicode = 'f456';
var svgPathData = 'M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8L0 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-154.3 426.7-150.1c3.2-1.1 5.3-4.2 5.3-7.5s-2.1-6.4-5.3-7.5L16 34.3 16 8zm0 43.3L415.9 192 16 332.7 16 51.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlagPennant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;